import React, { useEffect, useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import styled from "styled-components";
import image from "../../Assests/Frame 2147225130124.svg";
import playstore from "../../Assests/bxl_play-store.svg";

const Tymeplusmobile = ({ setScrollItem }) => {
  const handlePlayStoreClick = () => {
    window.open(
      "https://play.google.com/store/apps/details?id=com.app.foresytshr",
      "_blank",
    );
  };

  const mobileRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // when mobile section is at least 50% visible, clear the scroll item
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            if (setScrollItem) setScrollItem("");
          }
        });
      },
      { threshold: [0.5] },
    );

    const node = mobileRef.current;
    if (node) observer.observe(node);

    return () => {
      if (node) observer.unobserve(node);
    };
  }, [setScrollItem]);

  return (
    <div ref={mobileRef}>
      <MobileWrap>
        <Container>
          <Row className="pb-5 pt-5 mb-4">
            <Col lg={6} md={12} xs={12}>
              <div className="mobile-img">
                <img src={image} width="70%" alt="ForesytsHR mobile" />
              </div>
            </Col>
            <Col lg={6} md={12} xs={12}>
              <div className=" py-4 my-4 text-start mobile-contain">
                <h3 className="color3 text1 pt-4">ForesytsHR</h3>
                <p className="color2 text2 py-4">
                  With the mobile app, you can access all your organizational
                  management tools right from your smartphone. Whether you're in
                  the office, on the go, or working remotely, stay connected and
                  productive wherever you are.
                </p>
                <h2 className="color3 text3 mt-4">Download The App Now</h2>
                <div className="py-4 d-flex btn-download">
                  <button
                    className="mobile-filldbtn d-flex me-2"
                    onClick={handlePlayStoreClick}
                  >
                    <img src={playstore} alt="Play Store" /> Play Store
                  </button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </MobileWrap>
    </div>
  );
};

export default Tymeplusmobile;

export const MobileWrap = styled.div`
  .text1 {
    font-size: 40px;
    font-weight: 700;
  }

  .mobile-img {
    display: flex !important;
    justify-content: center !important;
  }

  .text2 {
    font-size: 16px;
    font-weight: 400;
    padding-right: 22%;
  }

  .text3 {
    font-size: 20px;
    font-weight: 700;
  }

  .mobile-filldbtn {
    width: 170px;
    color: #ffffff;
    font-size: 18px;
    font-weight: 500;
    border: 2px solid #1f243b;
    background-color: #1f243b;
    border-radius: 10px;
    padding: 8px 24px;
  }

  @media screen and (max-width: 768px) {
    .mobile-img {
      display: flex !important;
      justify-content: center !important;
    }
    .btn-download {
      padding-left: 0rem !important;
      padding-right: 0rem !important;
      text-align: center;
      justify-content: center;
    }

    .mobile-filldbtn {
      width: 150px;
      padding: 8px 14px !important;
    }

    .mobile-contain {
      padding-left: 0px !important;
      padding-right: 0px !important;
      text-align: center !important;
    }

    .text1 {
      font-size: 20px;
      font-weight: 700;
    }

    .text2 {
      font-size: 16px;
      font-weight: 400;
      padding-right: 5% !important;
      padding-left: 5% !important;
    }
  }
`;
